<template>
	<v-row>
		<v-dialog v-model="showDialog" scrollable persistent max-width="1050px" min-height="400px">
			<v-skeleton-loader v-if="loading" type="article, actions" />
			<v-card v-if="!loading">
				<v-card-title class="px-2 py-0">
					<v-col cols="12" class="d-flex justify-space-between align-center">
						<div class="d-flex align-center">
							<h4>
								{{ $t('modules.assessment-report.dialog.title') }}
							</h4>
							<span class="ml-4" style="margin-top: 4px; font-size: 1rem; color: #C3271A;">{{ data.code }}</span>
						</div>
						<v-btn icon class="d-print-none" @click="showDialog=false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-col>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pb-0 black--text" @wheel="onWheel">
					<v-container class="my-0">
						<!--<v-row class="my-2" style="border: 2px solid #E4E4E4; border-radius: 5px; background-color: #F4F4F4;">
							<v-col cols="12" class="pb-3">
								<h3>{{ $t('modules.assessment-report.dialog.assessment_code') }} {{ data.code }}</h3>
							</v-col>
						</v-row>-->
						<v-row class="my-2" style="border: 2px solid #E4E4E4; border-radius: 5px; background-color: #F4F4F4;">
							<v-col cols="12" class="pb-3">
								<h3>{{ $t('modules.assessment-report.dialog.candidate_id') }} {{ data.candidateId }}</h3>
								<h3>{{ $t('modules.assessment-report.dialog.candidate_name') }} {{ `${data.candidateLastname}, ${data.candidateFirstname}` }}</h3>
							</v-col>
						</v-row>
						<v-row v-for="module in modulesByAssessment" :key="module.id" class="my-3">
							<v-col cols="12">
								<v-row style="border: 0px solid #E4E4E4; border-radius: 5px; background-color: #f2d0cd;">
									<v-col cols="12" class="py-1">
										<h3 class="d-block">{{ $t(`common.assessment.modules.${module.moduleId}`) }}</h3>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="12">
								<v-row v-for="(result, index) in getResultsByModule(module.results)" :key="index" class="py-0">
									<v-row class="ma-0 py-0">
										<v-col cols="7" class="py-2">
											<h4>{{ $t(`common.assessment.modules.skills.${Object.keys(result)[0]}`) }}</h4>
										</v-col>
										<v-col cols="5" class="py-2">
											<h4 class="ml-8">{{ parseValue(Object.values(result)[0]) }}</h4>
										</v-col>
									</v-row>
								</v-row>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
				<v-divider class="d-print-none"></v-divider>
				<v-card-actions class="d-print-none">
					<v-spacer></v-spacer>
					<v-btn text color="#C3271A" @click="print()" style="font-size: 0.9em; font-weight: 400;">
						<!--<v-icon color="#C3271A" class="mr-1">mdi-printer</v-icon>-->
						{{ $t('common.dialog-buttons.print') }}
					</v-btn>
					<v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">
						{{ $t('common.dialog-buttons.close') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import BaseModule from '../common/BaseModule.js';
import api from '../../api/humanway.js';

export default {
	name: 'AssessmentReportDialog',
	mixins: [BaseModule],
	components: {
	},
	data() {
		return {
			showDialog: false,
			loading: false,
			data: {},
			skills: [],
		}
	},
	computed: {
		modulesByAssessment() {
			if (!this.data.modulesByAssessment) {
				return [];
			}
			return this.data.modulesByAssessment.filter(m => m.processedDate);
		}
	},
	methods: {
		onWheel(event) {
			event.stopPropagation();
		},
		open(data) {
			this.data = data;
			this.showDialog = true;

			this.loading = true;

			api.getSkills(
				res => {
					this.skills = res.entities;
					this.loading = false;
				},
				error => {
					this.$log.error(error);
					this.$emit('show-alert', { text: error, color: 'error' });
					this.loading = false;
				}
			);
		},
		getResultsByModule(results) {
			try {
				return JSON.parse(results);
			} catch (error) {
				return [];
			}
		},
		parseValue(value) {
			if (!value || value.startsWith('Error:')) {
				return '---';
			}
			return value;
		},
		print() {
			window.print();
		}
	}
}
</script>